import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { headTab } from '../config/constants';
import { BasicTab } from '../config/type';

type Props = {
  active: BasicTab;
  onChange: (tab: BasicTab) => void;
  className?: string;
};

export default function Tabs({ active, onChange, className }: Props) {
  return (
    <Nav tabs className={className ?? 'border-tab border-0 mb-0 nav-danger'}>
      {headTab.map((item) => (
        <NavItem key={item.id}>
          <NavLink
            href="#"
            onClick={(e) => { e.preventDefault(); onChange(item.codice as BasicTab); }}
            className={`nav-border text-danger nav-danger ${item.id === '1' ? 'pt-0' : ''} ${active === item.codice ? 'active' : ''}`}
          >
            <span className="d-inline-flex align-items-center gap-2">
              {item.icon}
              <span>{item.text}</span>
            </span>
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
}
